module.exports = __webpack_public_path__ + "static/img/3.af96df89.png";